<script setup>
import {onBeforeMount, ref} from 'vue'
import createBicycleInventory from './components/createBicycleInventory/index.vue'
import { detailBicycles, editBicycles } from "@/api/bicycles/bicycles.js"
import {getRoute} from "@/hooks/getRoute.js";
import router from "@/router/index.js";

/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 加载状态
const loading = ref(false)
// 带参则为修改
const isEdit = ref(false)
onBeforeMount(async () => {
  isEdit.value = Boolean(route.query.bicycleId)
  if (isEdit.value) {
    await getDetail()
  } else {
    ElMessage.error("信息获取失败")
    loading.value = true
  }
})

/*表单信息相关*/
// 表单
const ruleForm = ref({
  assetOwner: "BIKING UP",
  brandName: null,
  model: null,
  color: null,
  ageRange: null,
  providerSponsor: null,
  conditionLevel: null,
  bicycleQuantity: 0,
  currentVenue: null,
  placementDate: null,
  bicycleId: null,
  boundCount: 0
})
// 编辑车辆锚点
const createBicycleInventoryRef = ref()
// 获取车辆详情
const getDetail = async () => {
  try {
    loading.value = true
    const res = await detailBicycles(route.query.bicycleId)
    ruleForm.value = {
      ...ruleForm.value,
      ...res,
      bicycleId: res?.bicycleId || route.query.bicycleId
    }
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 处理提交修改车辆
const handleEditBicycles = async () => {
  try {
    loading.value = true
    await editBicycles(ruleForm.value)
    ElMessage.success("修改成功")
    router.push("/listBicycleInventory")
  } catch (e) {
    console.log(e)
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div v-loading="loading" style="height: 100%">
    <createBicycleInventory
        ref="createBicycleInventoryRef"
        :isEdit="true"
        v-model="ruleForm"
        :loading="loading"
        @success="handleEditBicycles"
        @reGetDetail="getDetail"
    ></createBicycleInventory>
  </div>
</template>

<style lang="scss" scoped>

</style>
